import * as React from 'react'

export interface ErrorBoundaryProps {
  children: React.ReactNode
  fallback?: React.ReactNode | ((error: Error) => React.ReactNode)
}

interface ErrorBoundaryState {
  error: Error | null
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error }
  }

  render() {
    const { error } = this.state
    if (error) {
      if (typeof this.props.fallback === 'function') {
        return this.props.fallback(error)
      }
      if (this.props.fallback) {
        return this.props.fallback
      }
      return (
        <div className="flex flex-col items-center justify-center gap-1 p-6 text-center text-sm text-txt-secondary">
          <div className="font-medium text-txt-primary">
            Something went wrong loading this
          </div>
          <div className="text-xs">Try refreshing the page.</div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
